var links = document.querySelectorAll(".tabs-link");

var graphsList= document.querySelectorAll('.graphs__list-el').forEach(item => {
    item.addEventListener('click', function (e) {

            item.classList.toggle("graphs__list-el--clicked")
        
    })
});



for (var i = 0; i < links.length; i++) {
    var link = links[i];
    link.addEventListener("click", function (e) {
        // Cacher les tabs
        e.preventDefault();
        var contents = document.querySelectorAll(".tabs-content");

        for (var _i = 0; _i < contents.length; _i++) {
            contents[_i].classList.add("hide");
        } // Activer un Tab


        var href = e.currentTarget.getAttribute("href");
        var activeTab = document.querySelector(href);
        activeTab.classList.remove("hide");
    });
} //GRAPH 1 - REGIONS


var regions = [];
var dimensions = [];
var mixregion = [];
fetch("http://tomdelfosse.be/projets/data-play/assets/data/abandonedfinal.json").then(function (response) {
    return response.json();
}).then(function (data) {
    var items = data.places;
    items.forEach(function (item) {
        var region = item.region;
        var found = regions.find(function (element) {
            return element === region;
        });
        mixregion.push(region);

        if (found === undefined) {
            regions.push(region);
        }
    });
    regions.forEach(function (element) {
        var dimension = mixregion.filter(function (elem) {
            return elem === element;
        }).length;
        dimensions.push(dimension);
    });
    var ctx = document.getElementById('graph1').getContext('2d');
    var options = {
        legend: {
            position: 'bottom',
            labels: {
                fontFamily: "Alegreya, serif",
                fontStyle: "Italic"
            }
        },
        scales: {
            xAxes: [{
                gridLines: {
                    color: "#FAF3E6",
                },
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }],
            yAxes: [{
                gridLines: {
                },
                ticks: {
                    max: 10,
                    min: 0,
                    stepSize: 2,
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }]
        }
    };
    var data = {
        labels: regions,
        datasets: [{
            label: 'Nombre de lieux par régions',
            backgroundColor: '#A41029',
            data: dimensions
        }]
    };
    var config = {
        type: 'bar',
        data: data,
        options: options
    };
    var graph1 = new Chart(ctx, config);
}); //GRAPH 2 - PROVINCES

var provinces = ['Namur', 'Brabant Wallon'];
var sizes = [];
var mixprovince = [];
fetch("http://tomdelfosse.be/projets/data-play/assets/data/abandonedfinal.json").then(function (response) {
    return response.json();
}).then(function (data) {
    var items = data.places;
    items.forEach(function (item) {
        var province = item.province;
        var found = provinces.find(function (element) {
            return element === province;
        });
        mixprovince.push(province);

        if (found === undefined) {
            provinces.push(province);
        }
    });
    provinces.forEach(function (element) {
        var size = mixprovince.filter(function (elem) {
            return elem === element;
        }).length;
        sizes.push(size);
    });
    var ctx = document.getElementById('graph2').getContext('2d');
    var options = {
        legend: {
            position: 'bottom',
            labels: {
                fontFamily: "Alegreya, serif",
                fontStyle: "Italic"
            }
        },
        scales: {
            xAxes: [{
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }],
            yAxes: [{
                ticks: {
                    max: 4,
                    min: 0,
                    stepSize: 1,
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }]
        }
    };
    var data = {
        labels: provinces,
        datasets: [{
            label: 'Nombre de lieux par provinces',
            backgroundColor: '#A41029',
            data: sizes
        }]
    };
    var config = {
        type: 'bar',
        data: data,
        options: options
    };
    var graph2 = new Chart(ctx, config);
}); //GRAPH 3 - STATUTS

var states = [];
var tailles = [];
var mixstate = [];
fetch("http://tomdelfosse.be/projets/data-play/assets/data/abandonedfinal.json").then(function (response) {
    return response.json();
}).then(function (data) {
    var items = data.places;
    items.forEach(function (item) {
        var state = item.state;
        var found = states.find(function (element) {
            return element === state;
        });
        mixstate.push(state);

        if (found === undefined) {
            states.push(state);
        }
    });
    states.forEach(function (element) {
        var taille = mixstate.filter(function (elem) {
            return elem === element;
        }).length;
        tailles.push(taille);
    });
    var ctx = document.getElementById('graph3').getContext('2d');
    var options = {
        legend: {
            position: 'bottom',
            labels: {
                fontFamily: "Alegreya, serif",
                fontStyle: "Italic"
            }
        },
        scales: {
            xAxes: [{
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }],
            yAxes: [{
                ticks: {
                    max: 8,
                    min: 0,
                    stepSize: 2,
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }]
        }
    };
    var data = {
        labels: states,
        datasets: [{
            label: 'Nombre de lieux par status des lieux',
            backgroundColor: '#71AE87',
            data: tailles
        }]
    };
    var config = {
        type: 'line',
        data: data,
        options: options
    };
    var graph3 = new Chart(ctx, config);
}); //GRAPH 4 - DESCRIPTIONS

var types = [];
var heights = [];
var mixtype = [];
fetch("http://tomdelfosse.be/projets/data-play/assets/data/abandonedfinal.json").then(function (response) {
    return response.json();
}).then(function (data) {
    var items = data.places;
    items.forEach(function (item) {
        var type = item.type;
        var found = types.find(function (element) {
            return element === type;
        });
        mixtype.push(type);

        if (found === undefined) {
            types.push(type);
        }
    });
    types.forEach(function (element) {
        var height = mixtype.filter(function (elem) {
            return elem === element;
        }).length;
        heights.push(height);
    });
    var ctx = document.getElementById('graph4').getContext('2d');
    var options = {
        legend: {
            position: 'bottom',
            labels: {
                fontFamily: "Alegreya, serif",
                fontStyle: "Italic"
            }
        },
        scales: {
            xAxes: [{
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }],
            yAxes: [{
                ticks: {
                    max: 8,
                    min: 0,
                    stepSize: 2,
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }]
        }
    };
    var data = {
        labels: types,
        datasets: [{
            label: 'Nombre de lieux par types de lieux',
            backgroundColor: '#71AE87',
            data: heights
        }]
    };
    var config = {
        type: 'line',
        data: data,
        options: options
    };
    var graph4 = new Chart(ctx, config);
}); //GRAPH 5 - POINTS X & Y PAR SUPERFICIE

var points = [];
fetch("http://tomdelfosse.be/projets/data-play/assets/data/abandonedfinal.json").then(function (response) {
    return response.json();
}).then(function (data) {
    var items = data.places;
    items.forEach(function (item) {
        var object = {
            x: item.pointX,
            y: item.pointY,
            r: item.size
        };
        points.push(object);
    });
    var ctx = document.getElementById('graph5').getContext('2d');
    var options = {
        legend: {
            position: 'bottom',
            labels: {
                fontFamily: "Alegreya, serif",
                fontStyle: "Italic"
            }
        },
        scales: {
            xAxes: [{
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                },
                scaleLabel: {
                    display: true,
                    labelString: '15 : Très Grand - 10 : Grand - 5 : Petit',
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }],
            yAxes: [{
                ticks: {
                    fontFamily: "Alegreya, serif",
                    fontStyle: "Italic"
                }
            }]
        }
    };
    var data = {
        datasets: [{
            label: 'Point X & Point Y de chaque lieu par superficie',
            backgroundColor: '#379DB5',
            data: points
        }]
    };
    var config = {
        type: 'bubble',
        data: data,
        options: options
    };
    var graph5 = new Chart(ctx, config);
}); // Pour les graphiques, merci à
// Maxime Fondu : https://maximefondu.be/
// Chartjs : https://www.chartjs.org/
// Dev Theory : https://www.youtube.com/watch?v=2_VRcWKv-8Y
// Pour les tabs, merci à
// Mr Therasse : https://garith.be/
